import { createStyles } from '@mantine/core';

import { TIMEOUT } from '../constants';

export const useStyles = createStyles(
  (
    theme,
    {
      hasWrapperContent,
      isClosing,
      isOpen,
    }: {
      hasWrapperContent: boolean;
      isClosing: boolean;
      isOpen: boolean;
    }
  ) => ({
    container: {
      position: 'relative',
      width: '100%',
      backgroundColor: hasWrapperContent ? theme.colors.gray[0] : theme.white,
      borderRadius: `${theme.other.spacing._24}px ${theme.other.spacing._24}px 0 0`,
      overflow: 'hidden',
      alignSelf: 'end',
      display: (() => {
        if (isOpen || isClosing) {
          return hasWrapperContent ? 'block' : 'flex';
        }

        return 'none';
      })(),

      '&.enter': {
        transform: 'translateY(100%)',
      },
      '&.enter-active': {
        transform: 'translateY(0)',
        transition: `transform ${TIMEOUT}ms ease-in-out`,
      },
      '&.enter-done': {
        transform: 'translateY(0)',
      },
      '&.exit': {
        transform: 'translateY(0)',
      },
      '&.exit-active': {
        transform: 'translateY(100%)',
        transition: `transform ${TIMEOUT}ms ease-in-out`,
      },
      '&.exit-done': {
        transform: 'translateY(100%)',
      },
    },
    closeButton: {
      position: 'absolute',
      top: theme.other.spacing._16,
      right: theme.other.spacing._16,
      backgroundColor: theme.colors.gray[0],
      borderRadius: '100em',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.other.spacing._4,
      cursor: 'pointer',
      transition: 'opacity 150ms ease-in-out',
      zIndex: 5,

      '&:hover': {
        opacity: 0.5,
      },
    },
    wrapperContent: {},
    containerInner: {
      position: 'relative',
      width: '100%',
      borderRadius: `${theme.other.spacing._24}px ${theme.other.spacing._24}px 0 0`,
      ...(hasWrapperContent
        ? {
            backgroundColor: theme.white,
            borderRadius: `${theme.other.spacing._24}px ${theme.other.spacing._24}px 0 0`,
          }
        : {}),
    },
  })
);
